import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	resultLabel: {
		id: 'search-respository-result.label',
		defaultMessage: 'Repository',
		description: 'Search respository label',
	},
});
